module.exports = __webpack_public_path__ + "img/5.e2640e8a.png";